import React from 'react'
import ReactMarkdown from 'markdown-to-jsx'
import { styled } from '@mui/material/styles'
import Typography from '@mui/material/Typography'
import Link from '@mui/material/Link'

const options = {
  overrides: {
    h1: {
      component: props => (
        <Typography variant='h1' align='center' gutterBottom {...props} />
      )
    },
    h2: {
      component: props => (
        <Typography variant='h2' align='center' gutterBottom {...props} />
      )
    },
    h3: {
      component: props => (
        <Typography variant='h3' align='center' gutterBottom {...props} />
      )
    },
    h4: {
      component: props => (
        <Typography variant='h4' align='center' gutterBottom {...props} />
      )
    },
    h5: {
      component: props => (
        <Typography variant='h5' align='center' gutterBottom {...props} />
      )
    },
    h6: {
      component: props => (
        <Typography variant='h6' align='center' gutterBottom {...props} />
      )
    },
    p: { component: props => <Typography paragraph {...props} /> },
    a: { component: props => <Link {...props} /> },
    span: { component: props => <Typography component='span' {...props} /> },
    li: {
      component: styled(props => <Typography component='li' {...props} />)(
        ({ theme }) => ({
          marginTop: theme.spacing(0.5)
        })
      )
    }
  }
}

const Markdown = props => <ReactMarkdown options={options} {...props} />

export default Markdown
